import { Icon } from 'antd';
import { Link } from '@reach/router';
import cx from 'classnames';
import { forwardRef } from 'react';

import { ReactComponent as EditIcon } from 'assets/icons/edit-pencil.svg';
import { ReactComponent as UnmappedIcon } from 'assets/icons/field-unmapped.svg';
import AppConstants from 'utils/AppConstants';

import './FilteredDropdownItem.less';

export interface FilteredDropdownItemProps {
  id: string;
  title: string;
  onClick: (evt?: React.MouseEvent) => void;
  closePopover?: () => void;
  subtext?: string;
  selected?: boolean;
  to?: string;
  hasChanges?: boolean;
  ready?: boolean;
  isMapped?: boolean;
}

const FilteredDropdownItem = forwardRef<HTMLAnchorElement, FilteredDropdownItemProps>(
  ({ title, onClick, subtext, to = '', selected = false, closePopover, hasChanges, ready, isMapped }, ref) => (
    <Link
      ref={ref}
      to={to}
      role="button"
      aria-label={title}
      tabIndex={0}
      onClick={(e) => {
        onClick(e);
        closePopover?.();
      }}
      onKeyDown={(e) => {
        if (e.key === AppConstants.KEYBOARD_EVENT_KEYS.enter) {
          onClick();
          closePopover?.();
        }
      }}
      className={cx('synri-filtered-dropdown-item', {
        'is-selected': selected,
        'is-draft': hasChanges && !ready,
        'is-ready': ready,
      })}>
      <span className="item-title-row">
        <span className="item-title">{title}</span>
        {isMapped === false && !hasChanges && (
          <span className="item-unmapped-badge">
            <UnmappedIcon />
          </span>
        )}
      </span>
      {subtext && <span className="item-subtext">{subtext}</span>}
    </Link>
  )
);

export default FilteredDropdownItem;
